import React, { createContext, useContext, useState } from 'react';
import type { FORM_REGION } from '../interfaces';

type FormContextType = {
    setRegionContext: (region: FORM_REGION | undefined) => void;
    regionContext: FORM_REGION | undefined;
};
const FormContext = createContext<FormContextType | undefined>(undefined);

type FormContextProviderProps = {
    children: React.ReactNode;
    initialRegion: FORM_REGION | null;
};
export const FormContextProvider = ({
    children,
    initialRegion,
}: FormContextProviderProps) => {
    const [regionContext, setRegionContext] = useState<FORM_REGION | undefined>(
        initialRegion ?? undefined,
    );

    return (
        <FormContext.Provider
            value={{
                setRegionContext,
                regionContext,
            }}
        >
            {children}
        </FormContext.Provider>
    );
};

export const useFormContext = () => {
    const ctx = useContext(FormContext);
    if (!ctx) {
        throw new Error(
            'useFormContext must be used inside FormContextProvider',
        );
    }
    return ctx;
};
